export const compliance = {
list: {
  chaseFailedBody: "Compruebe la conexión e inténtelo de nuevo. Si sigue fallando, abra el documento y valídelo usted o hable directamente con el validador.",
  chaseFailedTitle: "Recordatorio no enviado",
  chaseSentBodyUnnamed: "El validador recibe una notificación para validarlo. Cada persona recibe como máximo un recordatorio al día.",
  chaseSentBody: "{{name}} recibe una notificación para validarlo. Cada persona recibe como máximo un recordatorio al día.",
  chaseSentTitle: "Recordatorio enviado",
  showWorkspace: "Mostrar todo el espacio de trabajo",
  noWorkspaceDescription: "El cumplimiento se muestra por espacio de trabajo. Únase a uno o cree uno para verlo aquí.",
title: "Cumplimiento",
subtitle_one: "{{count}} requisito",
subtitle_other: "{{count}} requisitos",
searchPlaceholder: "Buscar activos, documentos",
searchA11y: "Buscar cumplimiento",
refine: "Refinar",
refineSheetTitle: "Refinar cumplimiento",
clearFilters: "Borrar filtros",
loadMore: "Cargar más",
emptyTitle: "Nada que demostrar todavía",
emptyDescription: "Abra un activo y añada un certificado u otro documento con fecha de caducidad. Aparecerá aquí con su vencimiento.",
emptyAction: "Ir a activos",
noMatchTitle: "Ningún requisito coincide",
noMatchDescription: "Ningún requisito de cumplimiento coincide con los filtros aplicados.",
errorTitle: "No se pudo cargar el cumplimiento",
unscopedTitle: "Elige un espacio de trabajo",
unscopedDescription: "El cumplimiento abarca todo el espacio de trabajo y solo está viendo sus propios elementos. Toque Mostrar todo el espacio de trabajo.",
subtitle_many: "{{count}} requisitos",
},
bucket: {
compliant: "OK",
expiring: "Por caducar",
overdue: "Vencido",
invalid: "Rechazado",
pending: "Pendiente de validación",
missing_evidence: "Falta",
unknown: "Desconocido",
},
bucketA11y: {
compliant_one: "{{count}} conforme",
compliant_many: "{{count}} conformes",
compliant_other: "{{count}} conformes",
expiring_one: "{{count}} por caducar",
expiring_many: "{{count}} por caducar",
expiring_other: "{{count}} por caducar",
overdue_one: "{{count}} vencido",
overdue_many: "{{count}} vencidos",
overdue_other: "{{count}} vencidos",
invalid_one: "{{count}} rechazado",
invalid_many: "{{count}} rechazados",
invalid_other: "{{count}} rechazados",
pending_one: "{{count}} pendiente de validación",
pending_many: "{{count}} pendientes de validación",
pending_other: "{{count}} pendientes de validación",
missing_evidence: "{{count}} sin evidencia",
unknown_one: "{{count}} desconocido",
unknown_many: "{{count}} desconocidos",
unknown_other: "{{count}} desconocidos",
},
state: {
overdue: "vencido",
overdueBy_one: "vencido hace {{count}} día",
overdueBy_other: "vencido hace {{count}} días",
expiring: "por caducar",
expiresToday: "caduca hoy",
expiresIn_one: "caduca en {{count}} día",
expiresIn_other: "caduca en {{count}} días",
evidenceMissing: "falta evidencia",
rejected: "rechazado",
awaitingValidation: "pendiente de validación",
nothingRecorded: "nada registrado",
inDate: "en vigor",
validFor_one: "válido durante {{count}} día",
validFor_other: "válido durante {{count}} días",
overdueBy_many: "vencido hace {{count}} días",
expiresIn_many: "caduca en {{count}} días",
validFor_many: "válido durante {{count}} días",
},
action: {
upload_evidence: "Añadir evidencia",
renew: "Renovar",
replace_rejected: "Reemplazar",
chase_validation: "Recordar al validador",
record_expiry: "Añadir fecha de caducidad",
review_asset: "Revisar activo",
none: "",
schedule_inspection: "Inspeccionar",
},
row: {
responsible: "Responsable: {{name}}",
unassigned: "Sin aprobador designado",
sourceLocalRead: "Leído del documento",
sourceCloudAi: "Sugerido por IA",
sourceManual: "Introducido manualmente",
validatedBy: "Aceptado por {{name}}",
openA11y: "Abrir {{label}} en {{asset}}",
},
refine: {
status: "Estado",
site: "Sitio",
siteAny: "Cualquier sitio",
team: "Equipo",
teamAny: "Cualquier equipo",
assetType: "Tipo de activo",
asset: "Activo",
requirement: "Requisito",
due: "Vencimiento",
dueAny: "Cualquier momento",
due30: "Próximos 30 días",
due90: "Próximos 90 días",
sortBy: "Ordenar por",
groupBy: "Agrupar por",
},
sort: {
due_soonest: "Vencimiento más próximo",
severity: "Más urgente",
asset_az: "Activo A-Z",
},
group: {
none: "Sin agrupar",
status: "Estado",
asset: "Activo",
site: "Sitio",
requirement: "Requisito",
noSite: "Sin sitio",
noRequirement: "Nada declarado",
partialCount: "{{count}}+",
},
assetDetail: {
viewRegister: "Ver cumplimiento",
},
esg: {
loading: "Cargando cifras ESG…",
loadFailed: "No se pudieron cargar las cifras ESG.",
retry: "Reintentar",
notCoveredTitle: "ESG no está activo en este emplazamiento",
notCoveredBody: "Su espacio de trabajo tiene ESG solo en emplazamientos elegidos. Un administrador puede añadir este en Plan y facturación.",
noMetersTitle: "Aún no hay lecturas de energía",
noMetersBody: "Añada un contador (electricidad, gas, gasóleo, calor o agua) a un activo y registre lecturas. La energía y el carbono aparecen aquí al día siguiente, o al momento con Actualizar.",
byFuelTitle: "Energía por fuente (últimos 12 meses)",
byMonthTitle: "Energía por mes",
byMonthA11y: "Gráfico de barras de la energía usada cada mes en los últimos 12 meses",
unconverted: "Algunas lecturas usan una unidad que no podemos convertir a kWh y se omiten. Revise la unidad del contador.",
estimateNote: "El carbono es una estimación con los factores de conversión del Gobierno británico ({{year}}). Alcance 1 es combustible quemado in situ; alcance 2 es electricidad comprada.",
updatedAt: "Cifras calculadas {{when}}",
notYetComputed: "Aún no calculado. Pulse Actualizar.",
refresh: "Actualizar",
guideMe: "Guíame",
refreshing: "Actualizando…",
edit: "Editar",
save: "Guardar",
cancel: "Cancelar",
remove: "Quitar",
saveFailed: "No se pudo guardar. Compruebe la conexión e inténtelo de nuevo.",
floorAreaTitle: "Superficie",
floorAreaLabel: "Superficie (m²)",
floorAreaHint: "Se usa para energía y carbono por m². Incluya los emplazamientos internos solo si no tienen superficie propia.",
floorAreaInvalid: "Introduzca un número de metros cuadrados.",
floorAreaValue: "Superficie: {{m2}} m²",
kpi: {
energy: "Energía",
carbon: "Carbono",
intensity: "kWh por m²",
intensityUnit: "últimos 12 meses",
needsFloorArea: "Añada la superficie",
meters: "Contadores con lectura",
metersHint: "leídos en los últimos 3 meses",
water: "Agua",
vsLastYear: "{{change}} respecto al año anterior",
last12m: "últimos 12 meses",
scopes: "Alcance 1 {{s1}} · Alcance 2 {{s2}}",
      same: "Sin cambios",
      lower: "↓ {{pct}} %",
      higher: "↑ {{pct}} %",
      electricity: "Electricidad",
      electricityCarbon: "{{tonnes}} t CO₂e, últimos 12 meses",
      refrigerant: "Refrigerante",
      refrigerantGwp: "{{refrigerant}}, PCA {{gwp}}",
      fgasSize: "Cantidad de gas fluorado",
      fgasFormula: "{{kg}} kg × PCA {{gwp}}",
      fgasUnknownGwp: "PCA desconocido para este gas",
      leaked: "Fugado, últimos 12 meses",
      leakedTonnes: "{{tonnes}} t CO₂e fugadas",
      carbonCaption: "frente al año pasado, estimación",
      vsLastYearShort: "frente al año pasado",
      perM2: "Energía por m²",
      perM2Caption: "últimos 12 meses",
      allFuels: "todos los combustibles, últimos 12 meses",
},
fuel: {
electricity: "Electricidad",
gas: "Gas",
heat: "Calor",
oil: "Gasóleo",
water: "Agua",
},
refrigerant: {
title: "Refrigerante (gases fluorados)",
none: "No hay refrigerante registrado.",
add: "Añadir refrigerante",
summary_one: "{{count}} activo contiene {{tonnes}} t CO₂e de refrigerante; {{inBand}} necesitan control de fugas.",
summary_other: "{{count}} activos contienen {{tonnes}} t CO₂e de refrigerante; {{inBand}} necesitan control de fugas.",
summary_many: "{{count}} activos contienen {{tonnes}} t CO₂e de refrigerante; {{inBand}} necesitan control de fugas.",
overdue_one: "{{count}} control de fugas está vencido.",
overdue_other: "{{count}} controles de fugas están vencidos.",
overdue_many: "{{count}} controles de fugas están vencidos.",
assetLine: "{{refrigerant}}, {{kg}} kg ({{tonnes}} t CO₂eq)",
checkEvery: "Control de fugas cada {{months}} meses. Próximo {{next}}.",
noCheckNeeded: "Por debajo del umbral de gases fluorados: no se necesita control periódico.",
leakDetectionRequired: "Con este tamaño la normativa exige un sistema de detección de fugas.",
added12m: "{{kg}} kg añadidos en los últimos 12 meses",
typeLabel: "Refrigerante",
chargeLabel: "Carga (kg)",
chargeInvalid: "Introduzca la carga en kg.",
leakDetection: "Detección de fugas instalada",
hermetic: "Herméticamente sellado",
previewBand: "{{tonnes}} t CO₂e: control de fugas cada {{months}} meses.",
previewNone: "{{tonnes}} t CO₂e: no se necesita control periódico.",
planNote: "Añadimos el control de fugas al plan de este activo y mantenemos el intervalo correcto.",
logCheck: "Registrar control",
logLeak: "Registrar fuga",
logTopUp: "Registrar recarga",
logRecovered: "Registrar recuperación",
kgLabel: "Cantidad (kg)",
removeTitle: "¿Quitar el refrigerante?",
removeBody: "El plan de control de fugas de este activo termina. Se conserva el registro de controles anteriores.",
      edit: "Editar refrigerante",
      fromDetails: "Gas de los detalles del activo: {{refrigerant}}",
},
epc: {
title: "Certificados energéticos",
none: "No hay certificado registrado.",
add: "Añadir certificado",
ratingLabel: "Calificación",
validUntilLabel: "Válido hasta (AAAA-MM-DD)",
validUntil: "válido hasta {{date}}",
dateInvalid: "Introduzca la fecha como AAAA-MM-DD.",
refLabel: "Número de certificado",
isLet: "El edificio está alquilado",
belowMinimum: "Por debajo de E: un edificio alquilado en Inglaterra y Gales no puede alquilarse con esta calificación sin una exención.",
expired: "Caducado",
expiresSoon: "Caduca en menos de 6 meses",
documentNote: "Guarde el certificado en Documentos como Certificado de eficiencia energética para recibir un aviso antes de que caduque.",
removeTitle: "¿Quitar este certificado?",
      let: "Alquilado",
      notLet: "No alquilado",
      meetsStandard: "Cumple el mínimo para alquilar",
      open: "Abrir certificado",
      attachFile: "Adjuntar el archivo",
      noFile: "Aún no hay archivo adjunto",
      addRating: "Añadir la calificación",
      keptInDocuments: "Los certificados se guardan una sola vez, en Documentos. La calificación, la fecha y el recordatorio salen de ahí.",
},
sg: {
title: "Social y gobernanza",
hint: "De sus inspecciones y trabajos de los últimos 12 meses.",
compliance: "Cumplimiento",
risk: "Riesgo medio",
inspections: "Inspecciones",
signedOff: "{{done}} hechas, {{signed}} firmadas",
jobs: "Trabajos",
rework: "{{done}} hechos, {{rework}} repetidos",
contractors: "Contratistas usados",
      tile: {
        contractors: "Contratistas empleados",
        contractorsCaption: "seguro aún no registrado",
        safety: "Certificados de seguridad vigentes",
        findings: "Hallazgos corregidos a tiempo",
        signedOff: "Trabajo planificado aprobado",
        ofCount: "{{done}} de {{total}}",
        nothingYet: "aún no hay nada que contar",
      },
},
promptTitle: "ESG y sostenibilidad",
promptBody: "Vea energía, carbono, refrigerante y certificados energéticos de cada emplazamiento y activo, calculados con las lecturas que ya toma. Un complemento con precio por activo.",
promptAction: "Añadirlo en Plan y facturación",
promptAskAdmin: "Pida a un administrador que lo añada.",
promptNotInApp: "No disponible para comprar en la app.",
ai: {
title: "Redactar resumen",
hint: "Un breve resumen de estas cifras con acciones recomendadas. Cada número viene de arriba.",
reader: {
manager: "Para mí",
landlord: "Para un propietario",
investor: "Para un inversor",
},
write: "Redactar resumen",
again: "Redactar de nuevo",
writing: "Redactando…",
failed: "No se pudo redactar. Inténtelo de nuevo.",
noCredits: "Su espacio de trabajo no tiene créditos de IA.",
plainNote: "Resumen sencillo, sin usar créditos de IA.",
actionsTitle: "Acciones recomendadas",
do: {
job: "Crear trabajo",
inspection: "Inspeccionar",
reading: "Añadir lectura",
record: "Abrir",
},
},
portfolio: {
title: "ESG de la cartera",
hint: "Cada emplazamiento principal, últimos 12 meses.",
site: "Emplazamiento",
energy: "Energía",
change: "Cambio",
intensity: "kWh por m²",
carbon: "Carbono",
epc: "Certificado",
fgas: "Gases F",
overdue: "vencidos",
belowMinimum: "por debajo de E",
expiring: "caduca",
empty: "Aún no hay emplazamientos.",
workspaceTitle: "Todo el espacio de trabajo",
},
    period: "De {{from}} a {{to}}",
    addFloorArea: "Añadir superficie",
    addonBadge: "Complemento ESG",
    promptTitleAsset: "ESG de este activo",
    promptTitleSite: "ESG de esta ubicación",
    promptMeters_one: "Ya registra {{count}} contador aquí ({{kinds}}). Con el complemento ESG sus lecturas se convierten al instante en cifras de energía, carbono y comparación anual.",
    promptMeters_many: "Ya registra {{count}} contadores aquí ({{kinds}}). Con el complemento ESG sus lecturas se convierten al instante en cifras de energía, carbono y comparación anual.",
    promptMeters_other: "Ya registra {{count}} contadores aquí ({{kinds}}). Con el complemento ESG sus lecturas se convierten al instante en cifras de energía, carbono y comparación anual.",
    promptNothingHidden: "Nada de lo que registra se oculta ni se pierde: sus contadores, lecturas y documentos se quedan como están.",
    header: {
      floorArea: "{{value}} m² de superficie",
      rating: "Calificación {{scheme}} {{rating}}",
    },
    csv: {
      defaultName: "Datos ESG",
    },
    actions: {
      exportCsv: "Exportar CSV de ESG",
      share: "Compartir informe ESG",
      openAsset360: "Abrir Activo 360",
      openSite360: "Abrir Ubicación 360",
    },
    chart: {
      electricityTitle: "Electricidad por mes",
      energyTitle: "Energía por mes",
      subElectricity_one: "MWh, de {{count}} contador",
      subElectricity_many: "MWh, de {{count}} contadores",
      subElectricity_other: "MWh, de {{count}} contadores",
      subEnergy_one: "MWh, todos los combustibles, de {{count}} contador",
      subEnergy_many: "MWh, todos los combustibles, de {{count}} contadores",
      subEnergy_other: "MWh, todos los combustibles, de {{count}} contadores",
      a11y: "{{title}}: barras para cada uno de los últimos 12 meses y una línea discontinua para el mismo mes del año pasado",
      valueWithLastYear: "{{month}}: {{value}} MWh (año pasado {{last}} MWh)",
      value: "{{month}}: {{value}} MWh consumidos",
      tapHint: "Toque una barra para ver su valor.",
      thisYear: "Este año",
      lastYear: "Año pasado",
      metersReporting: "{{reporting}} de {{total}} contadores con datos (leídos en los últimos 3 meses)",
    },
    carbon: {
      title: "De dónde viene el carbono",
      sub: "Últimos 12 meses, estimación con factores de {{year}}",
      scope: "Alcance {{n}}",
      refrigerantLeak: "Fuga de refrigerante, {{name}}",
      none: "Aún no hay carbono calculado. Añada lecturas de contador o registre recargas de refrigerante.",
      fuelsTitle: "Energía por combustible",
    },
    fgas: {
      titleWithEpc: "Gases fluorados y certificados energéticos",
      none: "No hay refrigerante registrado en esta ubicación.",
      row: "{{name}}: {{refrigerant}}, carga de {{kg}} kg ({{tonnes}} t CO₂e)",
      overdue: "Control de fugas vencido",
      due: "Control de fugas el {{date}}",
      noCheck: "No necesita control de fugas",
      openJobFor: "Abrir trabajo de {{name}}",
      bookFor: "Programar control de fugas de {{name}}",
      jobTitle: "Control de fugas de gas fluorado: {{name}}",
      jobDescription: "Control de fugas del sistema de {{refrigerant}} ({{kg}} kg, {{tonnes}} t CO₂e) por un técnico certificado. Registre el resultado y el refrigerante añadido.",
    },
    leak: {
      title: "Controles de fugas",
      sub: "Con qué frecuencia las normas de gases fluorados exigen un control de fugas, según la cantidad en t CO₂e.",
      every: "Cada {{months}} meses",
      noneNeeded: "No necesario",
      band: {
        none: "Menos de 5 t",
        "5-50": "De 5 a 50 t",
        "50-500": "De 50 a 500 t",
        "500+": "500 t o más",
      },
      lastCheck: "Último control {{date}}: {{result}}",
      resultLeak: "fuga encontrada",
      resultPassed: "superado",
      noCheckYet: "Aún no hay controles de fugas registrados.",
      overdue: "Vencido desde el {{date}}",
      nextDue: "Próximo el {{date}}",
      openJob: "Abrir trabajo",
      logTitle: "Registro de fugas",
      logEmpty: "Aún no hay nada registrado.",
      event: {
        leak_check: "Control de fugas",
        leak_found: "Fuga encontrada",
        top_up: "Recargados {{kg}} kg",
        recovered: "Recuperados {{kg}} kg",
      },
      showFewer: "Mostrar menos",
      seeAll: "Ver los {{total}}",
      callout: "Cada recarga cuenta como una fuga: sus kg × PCA se suman al carbono de alcance 1.",
    },
    units: {
      mwh: "{{value}} MWh",
      kwh: "{{value}} kWh",
      kg: "{{value}} kg",
      t: "{{value}} t",
      mwhAxis: "MWh",
    },
},
};
